<template>
  <div
    class="text-black px-5 h-page"
    v-if="indication"
  >
    <div class="flex justify-end text-2xl">
      <i
        @click="close"
        class="el-icon-close cursor-pointer"
      ></i>
    </div>

    <div class="mb-4">
      <div
        class="text-2xl font-bold mb-1"
        v-if="user"
      >
        <span class="mr-1">{{user.name}}</span>
        <span>{{ getInfo() }}</span>
      </div>
      <div class="text-xl font-bold mb-1">
        {{ indication.indication_order.name }}
      </div>
      <div class="text-xl font-bold">
        {{ indication.name }}
      </div>
    </div>

    <!-- hanh chinh -->
    <div class="row mb-3">
      <div class="col-md-6 flex">
        <div class="fs-16 fw-400 txt-grey-900 w-28">Ngày chỉ định</div>
        <div class="fs-16 fw-700 ml-2">
          {{
        indication.indication_order &&
        formatDMY(indication.indication_order.ind_date) ? formatDMY(indication.indication_order.ind_date) : 'N/A'
      }}
        </div>
      </div>
      <div class="col-md-6 flex">
        <div class="fs-16 fw-400 txt-grey-900 w-28">Bác sĩ chỉ định</div>
        <div class="fs-16 fw-700 ml-2">
          {{
        indication.indication_order &&
        indication.indication_order.user &&
        indication.indication_order.user.name ? indication.indication_order.user.name : 'N/A'
      }}
        </div>
      </div>
      <div class="col-md-6 flex">
        <div class="fs-16 fw-400 txt-grey-900 w-28">Nơi thực hiện</div>
        <div class="fs-16 fw-700 ml-2">
          {{ getDataDemo(indication.target_id)  ? getDataDemo(indication.target_id) : 'N/A'}}
        </div>
      </div>
      <!-- <div class="col-md-6 flex">
          <div class="fs-14 fw-400 txt-grey-900 w-28">Ngày đến hạn</div>
          <div class="fs-14 fw-700 ml-2">{{ formatDate(indication.due_date) ? formatDate(indication.due_date) : 'N/A' }}</div>
        </div>

        <div class="flex">
          <div class="fs-14 fw-400 txt-grey-900 mb-0 w-28">Chẩn đoán</div>
          <div class="fs-14 fw-700 ml-2">{{ mr_master && mr_master.disease_main_name ? mr_master.disease_main_name : 'N/A' }}</div>
        </div> -->
    </div>
    <!-- hanh chinh -->
    <div>
      <div class="p-2">
        <!-- file -->
        <div class="mb-2">
          <div class="font-bold text-xl mb-2">
            Kết quả
          </div>
          <div
            class="mb-1"
            v-for="(file, index) in files"
            :key="index + 'file'"
          >
            <div class="
                      h-full
                      rounded-xl
                      p-2
                    ">
              <div class="row">
                <div
                  class="wrap col-md-8 cursor-pointer"
                  @click="downloadFile(file.file_name)"
                >
                  <span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_24814_125783)">
                        <path
                          d="M6.14703 0H14.1772L20.9748 7.09195V20.8779C20.9748 22.6023 19.5771 24 17.8526 24H6.14703C4.42256 24 3.0249 22.6023 3.0249 20.8779V3.12212C3.0249 1.39769 4.42256 0 6.14703 0V0Z"
                          fill="#0263D1"
                        />
                        <path
                          opacity="0.302"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.1675 0V7.0337H20.9747L14.1675 0Z"
                          fill="white"
                        />
                        <path
                          d="M6.95996 16.6667V12.7879H9.60769V13.5492H7.89746V14.3447H9.43913V15.1079H7.89746V16.6667H6.95996Z"
                          fill="white"
                        />
                        <path
                          d="M11.0173 12.7879V16.6667H10.0798V12.7879H11.0173Z"
                          fill="white"
                        />
                        <path
                          d="M11.6058 16.6667V12.7879H12.5433V15.9053H14.1569V16.6667H11.6058Z"
                          fill="white"
                        />
                        <path
                          d="M14.6423 16.6667V12.7879H17.3468V13.5492H15.5798V14.3447H17.2085V15.1079H15.5798V15.9053H17.3468V16.6667H14.6423Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_24814_125783">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  {{ file.name }}
                </div>
                <!-- <div class="wrap col-md-4">
                    <span>{{ file.created_by && file.created_by.name }}</span>
                    <span class="ml-3">{{ formatDMY(file.created_at) }}</span>
                  </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- file -->
        <!-- link -->
        <div>
          <div
            class="mb-2 row"
            v-for="(link, index) in links"
            :key="'link' + index"
          >
            <div class="text-base col-md-8 pl-3">
              <span
                class="cursor-pointer underline text-primary"
                @click="openLink(link)"
              >
                <span>
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.66672 11.9601L5.48672 13.1068C5.1773 13.4162 4.75764 13.5901 4.32005 13.5901C3.88247 13.5901 3.46281 13.4162 3.15339 13.1068C2.84397 12.7974 2.67014 12.3777 2.67014 11.9401C2.67014 11.5026 2.84397 11.0829 3.15339 10.7735L6.18005 7.74014C6.47713 7.4421 6.8774 7.26966 7.29806 7.25849C7.71873 7.24732 8.12758 7.39828 8.44005 7.68014L8.52005 7.74681C8.64647 7.87057 8.81688 7.93905 8.99379 7.93718C9.1707 7.9353 9.33962 7.86323 9.46339 7.73681C9.58716 7.61039 9.65563 7.43998 9.65376 7.26307C9.65188 7.08616 9.57981 6.91724 9.45339 6.79347C9.41576 6.74482 9.37571 6.6981 9.33339 6.65347C8.76429 6.15835 8.02828 5.89804 7.27443 5.92527C6.52059 5.9525 5.80528 6.26524 5.27339 6.80014L2.20672 9.83347C1.68562 10.4007 1.4038 11.1473 1.4201 11.9173C1.43641 12.6874 1.74957 13.4214 2.29421 13.966C2.83884 14.5106 3.57283 14.8238 4.34289 14.8401C5.11294 14.8564 5.85952 14.5746 6.42672 14.0535L7.58005 12.9268C7.69393 12.8026 7.75653 12.6398 7.75526 12.4713C7.75399 12.3028 7.68894 12.141 7.57319 12.0185C7.45745 11.896 7.29961 11.8219 7.13143 11.811C6.96325 11.8002 6.79721 11.8535 6.66672 11.9601ZM13.7934 2.46681C13.2326 1.90948 12.474 1.59666 11.6834 1.59666C10.8927 1.59666 10.1342 1.90948 9.57339 2.46681L8.42005 3.59347C8.30618 3.71771 8.24358 3.88046 8.24485 4.04898C8.24612 4.21751 8.31117 4.3793 8.42691 4.5018C8.54265 4.6243 8.7005 4.69841 8.86868 4.70924C9.03686 4.72006 9.2029 4.66679 9.33339 4.56014L10.4867 3.41347C10.7961 3.10405 11.2158 2.93022 11.6534 2.93022C12.091 2.93022 12.5106 3.10405 12.8201 3.41347C13.1295 3.72289 13.3033 4.14255 13.3033 4.58014C13.3033 5.01772 13.1295 5.43739 12.8201 5.74681L9.79339 8.78014C9.49631 9.07818 9.09604 9.25062 8.67538 9.26179C8.25472 9.27296 7.84586 9.122 7.53339 8.84014L7.45339 8.77347C7.32697 8.6497 7.15656 8.58123 6.97965 8.5831C6.80274 8.58498 6.63382 8.65705 6.51005 8.78347C6.38629 8.90989 6.31781 9.0803 6.31968 9.25721C6.32156 9.43412 6.39363 9.60304 6.52005 9.72681C6.56848 9.77633 6.61967 9.82307 6.67339 9.86681C7.24317 10.3604 7.97887 10.6198 8.73225 10.5926C9.48564 10.5653 10.2007 10.2536 10.7334 9.72014L13.7667 6.68681C14.3276 6.12952 14.6452 5.37296 14.6502 4.5823C14.6552 3.79165 14.3472 3.03113 13.7934 2.46681Z"
                      fill="#6E7883"
                    />
                  </svg>
                </span>
                <span class="ml-2 pl-1">{{ link.name }}</span>
              </span>
            </div>
            <!-- <div class="
                    col-md-4
                  ">
                <span>{{ link.created_by && link.created_by.name }}</span>
                <span class="ml-3">{{ formatDMY(link.created_at) }}</span>
              </div> -->
          </div>

        </div>
        <!-- link -->
      </div>

      <!-- mota -->
      <div class="mb-3 px-2">
        <div class="font-bold text-xl mb-2">
          Mô tả
        </div>
        <div v-html="examination_results && examination_results.description">

        </div>
      </div>
      <!-- mota -->

      <!-- ketluan -->
      <div class="mb-3 px-2">
        <div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
          <div class="font-bold text-xl mb-2">
            Kết luận
          </div>
        </div>
        <div v-if="conclusions">
          <div
            class="mb-2 ml-2"
            v-for="(conclusion, index) in conclusions"
            :key="'conclusion' + index"
          >
            <div class="text-base">{{ conclusion.conclusion }}</div>
            <div class="
                    flex
                    fs-14
                    font-bold
                    text-gray-500
                    justify-between
                    items-center
                  ">
              <!-- <div class="flex">
                  <div>{{ conclusion.user && conclusion.user.name }}</div>
                  <div class="ml-3">{{ formatDMY(conclusion.updated_at) }}</div>
                </div> -->
            </div>
          </div>
        </div>

      </div>
      <!-- ketluan -->
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import moment from 'moment'
import dataDemo from './dataMemo'
import _ from 'lodash'
import downloadS3 from '../../utils/downloadS3'
// import { mapState } from 'vuex'

export default {
  name: 'DetailIndication',
  data () {
    return {
      dialogVisible: false,
      loading: false,
      indication: null,
      mr_master: null,
      examination_results: null,
      links: [],
      conclusions: [],
      files: [],
      indicationId: this.$route.params.id,
      dataDemo,
      user: null
    }
  },
  computed: {
  },
  mounted () {
    if (this.indicationId) {
      this.getIndication(this.indicationId)
    }
    this.user = this.$user
  },
  methods: {
    getGender () {
      return appUtils.getGender(this.$user?.gender)
    },
    async getIndication (id) {
      this.loading = true
      await this.$rf.getRequest('AuthRequest').getIndicationById(id)
        .then(res => {
          this.indication = res.data
          this.mr_master = res.data?.indication_order?.medical_record?.medical_record_master
          this.conclusions = this.sortByDate(this.indication.conclusions)
          this.examination_results = res.data?.examination_results?.conclusion
          this.files = this.indication.files || []
          this.links = this.indication.links || []
        })
        .catch(error => {
          console.log('getIndication', error)
        }).finally(() => {
          this.loading = false
        })
    },
    getInfo () {
      let result = '('
      if (this.user.person?.gender) result = `${result}${appUtils.getGender(this.user.person?.gender)}`
      if (this.user.person?.age) result = `${result} - ${this.user.person.age}`
      if (this.user.person?.address) result = `${result} - ${this.user.person.address}`
      return result + ')'
    },
    formatDMY (date) {
      return date && moment(date).format('HH:mm DD-MM-YYYY')
    },
    formatDate (date) {
      return date && moment(date).format('DD-MM-YYYY')
    },
    getImageURL (avatar) {
      return appUtils.getImageURL(avatar)
    },
    openLink (link) {
      if (!link.url) return
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      if (isSafari) {
        if (confirm('Bạn đang được chuyển hương đến ' + link.url + '. Xác nhận chuyển hướng')) {
          window.location.href = link.url
        }
      } else window.open(link.url)
    },
    async downloadFile (name) {
      if (!name) return
      downloadS3.downloadFileRC(name)
    },
    getDataDemo (id) {
      return id ? this.dataDemo[id - 1].name : ''
    },
    sortByDate (data) {
      return _.orderBy(
        data,
        ['updated_at'],
        ['desc']
      )
    },
    close () {
      this.$router.go(-1)
    }
  }
}
</script>

  <style scoped lang="scss">
.h-page {
  min-height: calc(100vh - 150px);
}
</style>
